import { useState } from "react";
import { faq } from "@/mocks/site";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24">
      <div className="px-4 md:px-8 max-w-4xl mx-auto">
        <div className="text-center">
          <span className="text-sm font-medium text-primary-600 tracking-widest uppercase">
            FAQ
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            常见问答
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            关于这个类型、观看方式与注意事项，影迷最常问的几件事都在这里。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faq.map((item, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={item.q}
                className="rounded-lg bg-background-100 border border-background-200 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 md:px-6 md:py-5 text-left cursor-pointer"
                >
                  <span className="font-heading text-base md:text-lg font-bold text-foreground-950">
                    {item.q}
                  </span>
                  <span
                    className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-700"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 md:px-6 md:pb-6 text-sm md:text-base text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}